import { Box, useMediaQuery, useTheme } from '@mui/material';
import { EventDescription } from './EventDescription';
import { EventVideo } from './EventVideo';
import { EventRules } from './EventRules';
import { EventOrganizer } from './EventOrganizer';
import { AlreadyRegisteredSection } from './AlreadyRegisteredSection';
import { EventBanner } from './EventBanner';
import { useParams } from 'react-router-dom';
import type { ThemeCustomization } from '../types';

interface RefactoredPublicEventInfoProps {
    event: any;
}

export function RefactoredPublicEventInfo({ event }: RefactoredPublicEventInfoProps) {
    const { id, slug } = useParams();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('xs'));
    const basePath = slug ? `/evento/${slug}` : (event.slug ? `/evento/${event.slug}` : `/public/event/${id}`);

    return (
        <Box>
            {event.image && !isDesktop && (
                <Box sx={{ mb: 3 }}>
                    <EventBanner image={event.image} title={event.title} />
                </Box>
            )}

            <EventDescription
                eventId={event.id}
                title={event.title}
                startDate={event.start_date}
                endDate={event.end_date}
                startTime={event.start_time}
                endTime={event.end_time}
                description={event.description || ''}
                themeCustomization={event?.theme_customization}
            />

            {event.video_url && <EventVideo videoUrl={event.video_url} />}

            <EventRules
                rulesForChildren={event.rules_for_children}
                observations={event.observation}
                themeCustomization={event?.theme_customization}
            />

            <EventOrganizer
                name={event.organizer?.name}
                email={event.organizer?.email}
                phone={event.organizer?.phone}
                logo={event.organizer?.logo}
                showEmail={event.show_organizer_email !== false}
                showPhone={event.show_organizer_phone !== false}
                themeCustomization={event?.theme_customization}
            />

            <AlreadyRegisteredSection basePath={basePath} />
        </Box>
    );
}

